module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"domainAuthority":"Domain Authority"},"fr":{"domainAuthority":"Domain Authority"},"de":{"domainAuthority":"Domänenautorität"}}')
  delete Component.options._Ctor
}
